module.exports = __webpack_public_path__ + "static/tracer-dao-white-4ea0bad4984b53d9a5ab104f4d505ab0.png";